module.exports = __webpack_public_path__ + "img/loghi_0011_fundraiser_passione.74562fd2.png";